export default "__VITE_ASSET__f3a4e120__"